import React from 'react'

const Logo = ({ w, h }) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width={w} height={h} viewBox="0 0 308.000000 87.000000"
            preserveAspectRatio="xMidYMid meet">

            <g  transform="translate(0.000000,87.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M10 435 l0 -425 1530 0 1530 0 0 425 0 425 -1530 0 -1530 0 0 -425z
m3040 0 l0 -405 -1510 0 -1510 0 0 405 0 405 1510 0 1510 0 0 -405z"/>
                <path d="M100 460 l0 -320 823 2 822 3 3 318 2 317 -825 0 -825 0 0 -320z
m238 73 c2 -9 -11 -13 -47 -13 l-51 0 0 -35 c0 -35 0 -35 45 -35 57 0 59 -18
3 -22 -43 -3 -43 -3 -46 -45 -2 -24 -7 -43 -13 -43 -5 0 -9 46 -9 105 l0 106
57 -3 c34 -2 58 -8 61 -15z m191 -82 c46 -113 46 -111 27 -111 -8 0 -17 11
-20 25 -6 22 -11 25 -56 25 -44 0 -52 -3 -62 -25 -6 -14 -17 -25 -24 -25 -11
0 -9 13 7 53 36 93 68 157 77 157 5 0 28 -45 51 -99z m221 74 c17 -18 21 -28
13 -36 -8 -8 -14 -5 -23 10 -9 18 -19 22 -48 19 -48 -4 -52 -36 -7 -56 69 -29
80 -38 83 -64 2 -14 -4 -33 -13 -42 -21 -20 -84 -21 -113 0 -25 17 -29 44 -7
44 8 0 15 -4 15 -10 0 -16 41 -32 67 -25 40 10 27 46 -23 65 -54 20 -74 37
-74 66 0 53 89 73 130 29z m120 -20 l0 -45 55 0 55 0 0 45 c0 25 5 45 10 45 6
0 10 -42 10 -105 0 -63 -4 -105 -10 -105 -5 0 -10 20 -10 45 l0 45 -55 0 -55
0 0 -45 c0 -33 -4 -45 -15 -45 -12 0 -15 18 -15 105 0 87 3 105 15 105 11 0
15 -12 15 -45z m240 -60 c0 -63 -4 -105 -10 -105 -6 0 -10 42 -10 105 0 63 4
105 10 105 6 0 10 -42 10 -105z m224 95 c35 -13 59 -54 59 -102 0 -57 -44 -98
-106 -98 -50 0 -80 18 -97 59 -37 91 50 177 144 141z m208 -67 l53 -77 5 74
c3 46 10 75 18 78 9 3 12 -22 12 -102 0 -81 -3 -106 -13 -106 -7 0 -38 35 -68
78 l-54 77 -3 -77 c-2 -60 -6 -78 -17 -78 -12 0 -15 19 -15 98 0 140 7 143 82
35z"/>
                <path d="M462 473 c-5 -16 -13 -36 -17 -45 -6 -15 -1 -18 29 -18 20 0 36 4 36
9 0 12 -29 81 -34 81 -2 0 -9 -12 -14 -27z"/>
                <path d="M1232 497 c-59 -63 8 -160 88 -127 50 21 64 80 29 124 -27 35 -86 36
-117 3z"/>
                <path d="M1884 527 c-41 -36 -28 -73 36 -100 52 -22 61 -33 34 -44 -10 -4 -22
1 -29 10 -16 22 -65 23 -65 2 0 -8 9 -24 20 -35 41 -41 150 -16 150 34 0 23
-36 59 -71 71 -18 6 -35 17 -37 23 -4 14 34 16 43 2 3 -5 17 -10 31 -10 37 0
30 36 -13 59 -34 17 -69 13 -99 -12z"/>
                <path d="M2050 520 c0 -27 3 -30 30 -30 l30 0 0 -75 0 -75 30 0 30 0 0 75 0
75 30 0 c27 0 30 3 30 30 l0 30 -90 0 -90 0 0 -30z"/>
                <path d="M2298 533 c-56 -35 -66 -117 -19 -164 25 -25 37 -29 81 -29 44 0 56
4 81 29 43 43 41 101 -5 147 -27 27 -42 34 -72 34 -22 0 -51 -8 -66 -17z m100
-55 c28 -28 2 -88 -38 -88 -40 0 -66 60 -38 88 7 7 24 12 38 12 14 0 31 -5 38
-12z"/>
                <path d="M2507 543 c-4 -3 -7 -51 -7 -105 l0 -98 30 0 c27 0 30 3 30 30 0 19
5 30 14 30 7 0 19 -13 26 -30 10 -25 18 -30 46 -30 l35 0 -17 31 c-15 29 -15
34 2 64 24 45 13 82 -31 101 -35 14 -116 19 -128 7z m102 -52 c21 -13 5 -41
-24 -41 -20 0 -25 5 -25 25 0 26 22 33 49 16z"/>
                <path d="M2720 445 l0 -105 70 0 c68 0 70 1 70 25 0 23 -4 25 -40 25 -29 0
-40 4 -40 15 0 10 11 15 35 15 31 0 35 3 35 25 0 22 -4 25 -35 25 -24 0 -35 5
-35 15 0 11 11 15 41 15 36 0 40 2 37 23 -3 20 -9 22 -70 25 l-68 3 0 -106z"/>
            </g>
        </svg>

    )
}

export default Logo